import { useState, useEffect, useRef } from "react";
import { RotateCcw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { API, apiCall } from "@/lib/api";

const ReverifyStatus = ({ rv }) => {
  if (rv.status === "processing") {
    return <span className="flex items-center gap-1.5 text-xs text-amber-300" data-testid="reverify-status"><Loader2 className="w-3 h-3 animate-spin" />Re-verificando {rv.total} números del caché…</span>;
  }
  const label = rv.status === "paused_quota" ? "Cortado por cuota de RapidAPI" : rv.status === "error" ? "Terminó con error" : "Re-verificado";
  return (
    <span className="text-xs text-zinc-400" data-testid="reverify-status">
      {label}: {rv.verified}/{rv.total} · <b className="text-rose-300">{rv.si_to_no}</b> pasaron de SI a NO · <b className="text-green-300">{rv.no_to_si}</b> de NO a SI{rv.errors ? ` · ${rv.errors} con error` : ""}
    </span>
  );
};

export const ReverifyCachedPanel = ({ analysisId, reverify, onRefresh }) => {
  const [busy, setBusy] = useState(false);
  const running = reverify?.status === "processing";
  const refreshRef = useRef(onRefresh);
  refreshRef.current = onRefresh;

  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(() => refreshRef.current?.(), 4000);
    return () => clearInterval(t);
  }, [running]);

  const start = async () => {
    setBusy(true);
    try {
      const { ok, data } = await apiCall("POST", `${API}/admin/campaigns/${analysisId}/reverify-cached`);
      if (ok) { toast.success(data.message); onRefresh?.(); }
      else toast.error(data?.detail || "No se pudo iniciar");
    } catch { toast.error("No se pudo iniciar"); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex flex-wrap items-center gap-3 pt-1" data-testid="reverify-cached-panel">
      <Button size="sm" variant="outline" onClick={start} disabled={busy || running}
        className="bg-zinc-950 border-zinc-700 text-zinc-300 hover:text-white text-xs h-8" data-testid="reverify-cached-btn">
        {busy ? <Loader2 className="w-3 h-3 mr-1.5 animate-spin" /> : <RotateCcw className="w-3 h-3 mr-1.5" />}
        Re-verificar resultados del caché
      </Button>
      {reverify && <ReverifyStatus rv={reverify} />}
    </div>
  );
};
